import React, { useEffect, useState } from "react";
import { Button, Form } from "reactstrap";
import useAxios from "../../../../Utils/useAxios";
import {
  sumberDanaAxiosCreate,
  sumberDanaAxiosUpdate,
} from "../../../../Utils/axiosFunctions";
import { toastSuccess } from "../../../../Utils/toastFunctions";
import {
  berhasilMembuatItemMsg,
  berhasilMengubahItemMsg,
} from "../../../../Constant/Message";
import { InputField } from "../../../../CommonElements";

const SumberDanaForm = ({ resetState, toggle, sd }) => {
  const [state, setSdState] = useState({
    pk: 0,
    nama_sumber_dana: "",
  });

  useEffect(() => {
    if (sd) {
      const { pk, nama_sumber_dana } = sd;
      setSdState({
        pk: pk,
        nama_sumber_dana: nama_sumber_dana,
      });
    }
  }, [sd]);

  const axiosInstance = useAxios();

  const createSumberDana = (e) => {
    e.preventDefault();
    sumberDanaAxiosCreate(axiosInstance, state).then(() => {
      resetState();
      toggle();
      toastSuccess(berhasilMembuatItemMsg("sumber dana"));
    });
  };

  const editSumberDana = (e) => {
    e.preventDefault();
    sumberDanaAxiosUpdate(axiosInstance, state.pk, state).then(() => {
      resetState();
      toggle();
      toastSuccess(berhasilMengubahItemMsg("sumber dana"));
    });
  };

  return (
    <Form onSubmit={sd ? (e) => editSumberDana(e) : (e) => createSumberDana(e)}>
      <InputField
        state={state}
        label={"Nama Sumber Dana"}
        name={"nama_sumber_dana"}
        onChange={(e) => {
          setSdState((prev) => ({
            ...prev,
            nama_sumber_dana: e.target.value,
          }));
        }}
      />

      <Button color="primary">Simpan</Button>
    </Form>
  );
};

export default SumberDanaForm;
